export namespace LegalWarningAnalytics {
    // DL4.00
    export function openPopupScreen() {
        window.dataLayer.push({
            event: "action.show.18screen",
        });
    }

    // DL4.01
    export function closePopupScreen() {
        window.dataLayer.push({
            event: "action.closeByCross.18screen",
        });
    }
}
